import { createApi } from '@reduxjs/toolkit/dist/query/react';

import {
  getBaseQuery,
  getListProvidesTags,
  TransformedErrorResponseWithNotification,
  TransformedResponseWithNotification,
} from '../generic';
import * as endpoints from '../endpoints';
import { REDUX_CACHE, ACL, HTTP_METHOD, USERS } from '../constants';
import { IAcl } from '../../../types/interfaces/acl';
import { usersApi } from './usersApi';

export const aclApi = createApi({
  reducerPath: 'aclApi',
  tagTypes: [ACL.ACL_ITEM, REDUX_CACHE.ABORT_INVALIDATION, REDUX_CACHE.LIST],
  baseQuery: getBaseQuery(`/admin${endpoints.Acl.ROOT}`),
  // global configuration for the api
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getAclItemsApi: builder.query<IAcl[], void>({
      keepUnusedDataFor: 3600,
      query() {
        return {
          url: '',
          method: HTTP_METHOD.GET,
        };
      },
      providesTags: (result) => getListProvidesTags(result, ACL.ACL_ITEM),
      ...TransformedErrorResponseWithNotification(),
    }),
    postPutAclItemApi: builder.mutation<void, { id: string; body: IAcl }>({
      query({ id, body }) {
        return {
          url: id ? `/${id}` : '',
          method: id ? HTTP_METHOD.PUT : HTTP_METHOD.POST,
          body,
        };
      },
      async onQueryStarted(v, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(usersApi.util.invalidateTags([USERS.PERMISSIONS]));
      },
      invalidatesTags: (result, error, params) => {
        if (error) {
          return [REDUX_CACHE.ABORT_INVALIDATION];
        } else {
          return [
            {
              type: ACL.ACL_ITEM,
              id: REDUX_CACHE.LIST,
            },
            {
              type: ACL.ACL_ITEM,
              id: params.id,
            },
          ];
        }
      },
      ...TransformedResponseWithNotification('Rule'),
    }),
    deleteAclItemApi: builder.mutation<void, { id: string }>({
      query({ id }) {
        return {
          url: `/${id}`,
          method: HTTP_METHOD.DELETE,
        };
      },
      async onQueryStarted(v, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(usersApi.util.invalidateTags([USERS.PERMISSIONS]));
      },
      invalidatesTags: (result, error, params) => {
        if (error) {
          return [REDUX_CACHE.ABORT_INVALIDATION];
        } else {
          return [
            {
              type: ACL.ACL_ITEM,
              id: params.id,
            },
          ];
        }
      },
      ...TransformedResponseWithNotification('Rule'),
    }),
  }),
});

export const {
  useGetAclItemsApiQuery: useGetAclItems,
  usePostPutAclItemApiMutation: usePostPutAclItem,
  useDeleteAclItemApiMutation: useDeleteAclItem,
} = aclApi;
